import styled from 'styled-components'

export const Wrapper = styled.div`
  text-align: center;
  padding: 24px;
  border-radius: 4px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.16);
  max-width: 562px;
  overflow: hidden;
  background: #fff;
`

export const Title = styled.div`
  font-size: 32px;
  font-weight: 700;
  line-height: 40px;
  margin-bottom: 24px;
`

export const SubTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
`
